import { render, staticRenderFns } from "./AppHeaderLocale.vue?vue&type=template&id=19f8274a"
import script from "./AppHeaderLocale.vue?vue&type=script&lang=js"
export * from "./AppHeaderLocale.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderLocale.vue?vue&type=style&index=0&id=19f8274a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports